export default __webpack_public_path__ + "static/media/One-page-brochure-1.63fcbb5a.png";